module.exports = __webpack_public_path__ + "static/media/screen-6.b049343e.webp";